import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";

import apiURL from "../../store/actions/apiURL";
import { PencilSquareIcon, RectangleStackIcon, StarIcon } from "@heroicons/react/20/solid";
// import outline star icon
import { StarIcon as StarOutline } from "@/icons/outline";
import cleanDeep from "clean-deep";
import { connect } from "react-redux";
import { Actions as REPORT_ACTIONS } from "../../store/actions/reportActions";
import { format } from "date-fns";
import { NotificationManager } from "react-notifications";

const ReportRow = ({
    index,
    last,
    report,
    params,
    getReportData,
    updateFavouriteReports,
    favourited,
    isAdvisor
}) => {
	const navigate = useNavigate();

	const { name, id, company, supportedFileTypes, requiredFilters } = report;

	const [favourite, setFavourite] = useState(favourited);
	const [processing, setProcessing] = useState(index == 0);

	const disabled = useMemo(() => {
		return (requiredFilters && requiredFilters.some((filter) => !params[filter])) || isAdvisor;
	}, [params, requiredFilters]);

	const onClick = (e, fileType) => {
		// console.log('clicked',report)
		setProcessing(true);

		if (report.onClick) {
			report.onClick(e, params);
			setProcessing(false);
			// showReportPayPeriodModal(report.id);
			// setProcessing(false);
			// return;
		}

		// if (showModalOnPress) {
		// 	showReportPayPeriodModal(report.id);
		// 	setProcessing(false);
		// 	return;
		// }

		if (report.method == "s3Link") {
			e.preventDefault();
			e.stopPropagation();

			getReportData({
				setProcessing,
				report,
				params,
			});
		}
	};

	const canEdit = company !== "0" && !isAdvisor;

	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				lineHeight: 2,
				padding: "1.5rem",
				fontSize: "1.5rem",
				backgroundColor: index % 2 === 0 ? "rgb(244,244,244)" : "white",
				borderBottom: last ? "2px solid rgb(244,244,244)" : "none",
				borderBottomRightRadius: last ? "1rem" : "0rem",
				borderBottomLeftRadius: last ? "1rem" : "0rem",
				borderRight: "2px solid rgb(244,244,244)",
				borderLeft: "2px solid rgb(244,244,244)",
				opacity: disabled && !isAdvisor ? 0.5 : 1,
				cursor: disabled ? "not-allowed" : "pointer",
			}}
			onClick={(e) => {
				if (report.path) {
					// navigate to the report path using react router
					navigate(report.path);
				}

				!disabled && onClick(e, supportedFileTypes[0]);
			}}
		>
			<div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", flexGrow: 1 }}>
				{favourite ? (
					<StarIcon
						style={{ height: "2rem", marginRight: "0.5rem", cursor: "pointer", fill: "rgb(234,97,28)" }}
						onClick={(e) => {
							e.stopPropagation();
							if (!report?.id)
								return NotificationManager.error(
									"This report is missing an ID and cannot be used.",
									"Report Packs",
								);
							setFavourite(false);
							updateFavouriteReports(report?.id, false);
						}}
					/>
				) : (
					<StarOutline
						style={{ height: "2rem", marginRight: "0.5rem", cursor: "pointer", stroke: "rgb(234,97,28)" }}
						onClick={(e) => {
							e.stopPropagation();
							if (!report?.id)
								return NotificationManager.error(
									"This report is missing an ID and cannot be used.",
									"Report Packs",
								);
							setFavourite(true);
							updateFavouriteReports(report?.id, true);
						}}
					/>
				)}
				{name}
				{canEdit && (
					<Link
						type="button"
						data-toggle="tooltip"
						title="Edit Report"
						to={"/organisation/reports/" + id + "/"}
						onClick={(e) => {
							e.stopPropagation();
						}}
						style={{
							marginLeft: "0.5rem",
							alignSelf: "right",
						}}
					>
						<PencilSquareIcon style={{ height: "1.25rem", marginLeft: "0.5rem" }} />
					</Link>
				)}
			</div>

			<div>
				{["csv", "xlsx", "pdf", "link", "xml", "txt"]
					.filter((fileType) => report?.supportedFileTypes?.includes(fileType))
					.map((fileType) => {
						let icon = null;

						switch (fileType) {
							case "link":
								icon = <i className="fas fa-link" />;
								break;
							case "xlsx":
								icon = <i className="fas fa-file-excel" />;
								break;
							case "xml":
								// icon = <RectangleStackIcon/>
								icon = <i className="fas fa-file-code" />;
								break;
							case "txt":
								icon = (
									<svg
										className={"svg-inline--fa fa-w-12"}
										style={{ fill: "rgb(234, 97, 28)" }}
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 384 512"
									>
										<path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
									</svg>
								);
								break;
							case "csv":
							case "pdf":
							default:
								icon = <i className={`fas fa-file-${fileType}`} />;
						}

						if (isAdvisor) icon = null;

						return (
							<Link
								to={fileType == "link" ? report.path : "#"}
								target={undefined}
								onClick={(e) => {
									onClick(e, fileType);
								}}
								style={{
									color: "rgb(234,97,28)",
									textDecoration: undefined,
									cursor: "pointer",
									marginLeft: "0.75rem",
								}}
							>
								{icon}
							</Link>
						);
					})}
			</div>
		</div>
	);
};

// add redux state
const mapStateToProps = (state) => {
	const filters = state?.report?.filters || {};

	// selectedEmploymentType: state?.report?.filters?.employmentType,
	// selectedPeriod: state?.report?.filters?.period,

	const params = {
		start: filters?.startDate && format(filters.startDate, "yyyy-MM-dd"),
		end: filters?.endDate && format(filters.endDate, "yyyy-MM-dd"),
		group: filters?.checkGroupBy,
		totals: filters?.totalsOnly,
		department: filters?.department?.value,
		companyPayPeriod: filters?.period?.value,
	};
	return {
		params,
		// state
	};
};
//
const mapDispatchToProps = (dispatch) => ({
	// sendPayPeriodToXero: (id) => dispatch(PAYROLL_ACTIONS.sendPayPeriodToXero(id)),

	getReportData: (options) => dispatch(REPORT_ACTIONS.getReportData(options)),
	// concludePayroll: (id) => dispatch(PAYROLL_ACTIONS.concludePayroll({ id })),
	// // downloadAllPayslips: (id) => dispatch(PAYROLL_ACTIONS.downloadAllPayslips(id)),
	// downloadEmployeeForm: (data) => dispatch(FSS_ACTIONS.downloadEmployeeForm(data)),
	// // payrollUpdateId: (id) => dispatch(PAYROLL_ACTIONS.payrollUpdateId(id)),
	// downloadReport: (reportType, payPeriods, year, period) =>
	// 	dispatch(PAYROLL_ACTIONS.downloadReport(reportType, payPeriods, year, period)),
	// setBankTransferPeriod: (period) => dispatch(COMPANY_ACTIONS.setBankTransferPeriod(period)),
	// setBankTransferModal: () => dispatch(COMPANY_ACTIONS.setBankTransferModal(true)),
	// getPayrollUpdate: (payPeriodId) => dispatch(FYORIN_ACTIONS.getPayrollUpdate(payPeriodId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportRow);
